import { Link } from 'react-router-dom';

import Text from '@/components/ui/text';
import { Button } from '@/components/ui/button';

export type EmptyStateProps = {
  title?: string;
  description?: string;
  buttonText?: string;
  onButtonClick?: () => void;
  buttonTo?: string;
  buttonHref?: string;
  buttonTarget?: React.HTMLAttributeAnchorTarget;
  buttonRel?: string;
};

function EmptyState({
  title,
  description,
  buttonText,
  onButtonClick,
  buttonTo,
  buttonHref,
  buttonTarget,
  buttonRel,
}: EmptyStateProps) {
  const showButton = buttonText && (onButtonClick ?? buttonTo ?? buttonHref);
  return (
    <div
      data-slot="empty-state"
      className="flex flex-col items-center gap-5 p-8 sm:gap-4"
    >
      <div className="flex flex-col items-center gap-3 sm:gap-2">
        <Text size="lg" weight="bold">
          {title}
        </Text>
        {description && (
          <Text variant="body" size="base" className="max-w-md text-center">
            {description}
          </Text>
        )}
      </div>
      {showButton && buttonTo ? (
        <Button asChild>
          <Link to={buttonTo}>{buttonText}</Link>
        </Button>
      ) : showButton && buttonHref ? (
        <Button asChild>
          <a
            href={buttonHref}
            target={buttonTarget}
            rel={
              buttonRel ??
              (buttonTarget === '_blank' ? 'noopener noreferrer' : undefined)
            }
          >
            {buttonText}
          </a>
        </Button>
      ) : showButton ? (
        <Button onClick={onButtonClick}>{buttonText}</Button>
      ) : null}
    </div>
  );
}

export { EmptyState };
export default EmptyState;
